module.exports = __webpack_public_path__ + "img/ff9fec8c-e207-4a7f-9d3a-96b7d98baba2.d8b858a8.png";